// import React from 'react';
// import { Row, Col, Typography } from 'antd';
// import LoginForm from '../components/adminLogin/LoginForm';


// const { Title, Paragraph } = Typography;

// export default function LoginAdmin() {
//   const handleLogin = async ({ email, password }) => {
//     // TODO: remplace par ton appel API réel
//     await new Promise((res) => setTimeout(res, 900));

//     // Démo: identifiants acceptés
//     if (email === 'admin@demo.com' && password === 'admin123') {
//       // Exemple de redirection après succès
//       // window.location.href = '/admin';
//       return;
//     }
//     throw new Error('Identifiants invalides.');
//   };

//   return (
//     <Row
//       style={{
//         minHeight: '100vh',
//         background:
//           'radial-gradient(800px 400px at -10% -10%, #e0f2fe 0%, transparent 60%), radial-gradient(700px 350px at 110% 0%, #fce7f3 0%, transparent 60%), linear-gradient(180deg, rgba(0,0,0,0.03), rgba(0,0,0,0.04))',
//       }}
//       wrap={false}
//     >
//       {/* Colonne formulaire */}
//       <Col
//         xs={24}
//         md={12}
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '40px 20px',
//         }}
//       >
//         <div
//           style={{
//             width: '100%',
//             maxWidth: 450,
//             padding: 32,
//             borderRadius: 16,
//             background: 'rgba(255, 255, 255, 0.72)',
//             backdropFilter: 'blur(10px)',
//             WebkitBackdropFilter: 'blur(10px)',
//             boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
//             border: '1px solid rgba(0,0,0,0.06)',
//           }}
//         >
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
//             <div
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: 10,
//                 background: '#3B82F6',
//                 color: '#fff',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
             
//             </div>
//             <span style={{ fontWeight: 900 }}>MEDILINK</span>
//           </div>

//           <LoginForm onSubmit={handleLogin} />
//         </div>
//       </Col>

//       {/* Colonne branding/visuel */}
//       <Col
//         xs={0}
//         md={12}
//         style={{
//           position: 'relative',
//           overflow: 'hidden',
//           background: 'linear-gradient(135deg, #1f2937 0%, #1f2937 100%)',
//           color: 'white',
//           display: 'flex',
//           alignItems: 'center',
//           padding: 64,
//         }}
//       >
//         <div
//           style={{
//             position: 'absolute',
//             inset: 0,
//             background:
//               'radial-gradient(closest-side at 20% 20%, rgba(59,130,246,0.25), transparent 60%), radial-gradient(closest-side at 80% 65%, rgba(236,72,153,0.2), transparent 55%)',
//           }}
//         />
//         <div style={{ position: 'relative', zIndex: 1, maxWidth: 520 }}>
//           <Title level={2} style={{ color: 'white', marginBottom: 16 }}>
//             Gérez tout en un seul endroit
//           </Title>
//           <Paragraph style={{ color: 'rgba(255,255,255,0.85)' }}>
//             Un tableau de bord moderne, rapide et sécurisé pour piloter votre application,
//             avec une expérience fluide et responsive.
//           </Paragraph>
          
//         </div>
//       </Col>
//     </Row>
//   );
// }

import React from 'react';
import { Row, Col, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/adminLogin/LoginForm';
import { loginAdmin } from '../redux/thunks/adminThunks';

import { ADMIN_ROUTES } from '../../routes/patientRoutes/routePaths';

const { Title, Paragraph } = Typography;

export default function LoginAdmin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // LoginForm appellera cette fonction avec { email, password }
  // Si on throw ici → LoginForm attrape dans son catch et affiche l'Alert rouge
  // const handleLogin = async ({ email, password }) => {
  //   await dispatch(loginAdmin({ email, password })).unwrap();
  //   // .unwrap() propage l'erreur si rejected, sinon on redirige
  //   navigate('/admin/dashboard'); // adapte selon ton routing
  // };

const handleLogin = async ({ email, password }) => {
  try {
    const result = await dispatch(loginAdmin({ email, password })).unwrap();
    navigate(ADMIN_ROUTES.DASHBOARD, { replace: true });
  } catch (err) {
    console.error('❌ login error:', err);
    throw err;
  }
};

  return (
    <Row
      style={{
        minHeight: '100vh',
        background:
          'radial-gradient(800px 400px at -10% -10%, #e0f2fe 0%, transparent 60%), radial-gradient(700px 350px at 110% 0%, #fce7f3 0%, transparent 60%), linear-gradient(180deg, rgba(0,0,0,0.03), rgba(0,0,0,0.04))',
      }}
      wrap={false}
    >
      {/* Colonne formulaire */}
      <Col
        xs={24}
        md={12}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 450,
            padding: 32,
            borderRadius: 16,
            background: 'rgba(255, 255, 255, 0.72)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 10,
                background: '#3B82F6',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              M
            </div>
            <span style={{ fontWeight: 900 }}>MEDILINK</span>
          </div>

          {/* LoginForm reste identique, on lui passe juste le vrai handler */}
          <LoginForm onSubmit={handleLogin} />
        </div>
      </Col>

      {/* Colonne branding */}
      <Col
        xs={0}
        md={12}
        style={{
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #1f2937 0%, #1f2937 100%)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          padding: 64,
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(closest-side at 20% 20%, rgba(59,130,246,0.25), transparent 60%), radial-gradient(closest-side at 80% 65%, rgba(236,72,153,0.2), transparent 55%)',
          }}
        />
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 520 }}>
          <Title level={2} style={{ color: 'white', marginBottom: 16 }}>
            Gérez tout en un seul endroit
          </Title>
          <Paragraph style={{ color: 'rgba(255,255,255,0.85)' }}>
            Un tableau de bord moderne, rapide et sécurisé pour piloter votre application,
            avec une expérience fluide et responsive.
          </Paragraph>
        </div>
      </Col>
    </Row>
  );
}